module.exports = __webpack_public_path__ + "img/finland-cerebrovascular-disease-female.593627c5.png";